import { useState, useEffect } from "react";
import { THEMES } from "../constants/themes";
import type { Theme } from "../constants/themes";

const GH_VARS: Record<Theme, { ghBg: string; ghColor: string }> = {
  white: { ghBg: "#0a0a0a", ghColor: "#ffffff" },
  cream: { ghBg: "#0a0a0a", ghColor: "#ffffff" },
  dark: { ghBg: "#ffffff", ghColor: "#0a0a0a" },
  black: { ghBg: "#ffffff", ghColor: "#0a0a0a" },
};

function applyThemeVars(theme: Theme) {
  const c = THEMES[theme];
  const root = document.documentElement;
  root.style.setProperty("--bg", c.bg);
  root.style.setProperty("--bg-2", c.bg2);
  root.style.setProperty("--bg-3", c.bg3);
  root.style.setProperty("--border", c.border);
  root.style.setProperty("--text", c.text);
  root.style.setProperty("--text-muted", c.textMuted);
  root.style.setProperty("--text-dim", c.textDim);
  root.style.setProperty("--accent", c.accent);
  root.style.setProperty("--accent-dim", c.accentDim);
  root.style.setProperty("--accent-border", c.accentBorder);
  root.style.setProperty("--tag", c.tag);
  root.style.setProperty("--tag-text", c.tagText);

  const gh = GH_VARS[theme];
  root.style.setProperty("--gh-bg", gh.ghBg);
  root.style.setProperty("--gh-color", gh.ghColor);

  root.setAttribute("data-theme", theme);
}

export function useTheme() {
  const [theme, setTheme] = useState<Theme>("white");

  useEffect(() => {
    const saved = localStorage.getItem("lab-theme") as Theme | null;
    const initial = saved && ["dark", "black", "white", "cream"].includes(saved) ? saved : "white";
    setTheme(initial);
    applyThemeVars(initial);
  }, []);

  const changeTheme = (th: Theme) => {
    setTheme(th);
    localStorage.setItem("lab-theme", th);
    applyThemeVars(th);
  };

  return { theme, changeTheme };
}
